<template>
  <div class="custom-page-calendar-container" :class="[typeFlag===1&&'custom-page-calendar-runtime']">
    <el-calendar v-model="value">
    </el-calendar>
    <div v-if="typeFlag===0" class="footer">
      <el-button type="primary" @click="save">确定</el-button>
      <el-button @click="closeDialog">关闭</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'calendar',
  props: {
    data: {},
    typeFlag: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      value: new Date()
    }
  },
  methods: {
    save () {
      this.$emit('addControls', this.data, true)
    },
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style lang="scss">
  .custom-page-calendar-container{
    width: 100%;
    height: 100%;
    .el-calendar{
      .el-calendar__body{
        padding: 0 20px;
      }
      .el-calendar-table{
        thead{
          th{
            padding: 8px 0;
          }
        }
        .el-calendar-day{
          height: 72px;
        }
      }
    }
    .footer {
      padding-top: 10px;
      text-align: center;
      .el-button--primary {
        margin-right: 52px;
      }
      .el-button {
        padding: 0;
        width: 78px;
        height: 26px;
        line-height: 25px;
      }
    }
  }
  //  执行样式
  .custom-page-calendar-runtime{
    .el-calendar{
      .el-calendar__body{
        .el-calendar-table{
          .el-calendar-table__row{
            .el-calendar-day{
              height: 45px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/calendar.vue